import React from 'react';
import {
  Box,
  Checkbox,
  Chip,
  Grid,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Paper,
  Typography,
} from '@mui/material';
import AssignmentIcon from '@mui/icons-material/Assignment';
import EventIcon from '@mui/icons-material/Event';

const MOCK_TASKS = [
  { id: 't1', title: 'Respond to VIP payout inquiry', due: 'Today, 2:00 PM', priority: 'high' },
  { id: 't2', title: 'Complete KYC follow-up #8821', due: 'Today, 4:30 PM', priority: 'medium' },
  { id: 't3', title: 'Review macro updates for L1 team', due: 'Tomorrow', priority: 'low' },
];

const MOCK_EVENTS = [
  { id: 'e1', title: 'Shift handoff', when: 'Today · 6:00 PM', type: 'meeting' },
  { id: 'e2', title: 'Team standup', when: 'Wed · 10:00 AM', type: 'meeting' },
  { id: 'e3', title: 'Training: fraud playbook', when: 'Thu · 3:00 PM', type: 'training' },
];

function priorityColor(priority) {
  if (priority === 'high') return 'error';
  if (priority === 'medium') return 'warning';
  return 'default';
}

export default function AgentDashboard({ welcomeName, onOpenTickets }) {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        My workspace
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        Welcome back, {welcomeName}. Your assigned work and upcoming events.
      </Typography>

      <Grid container spacing={2}>
        <Grid size={{ xs: 12, md: 7 }}>
          <Paper variant="outlined" sx={{ p: 2.5 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <AssignmentIcon color="primary" />
                <Typography variant="h6">Assigned tasks</Typography>
              </Box>
              {onOpenTickets && (
                <Chip
                  label="Open tickets"
                  size="small"
                  clickable
                  color="primary"
                  variant="outlined"
                  onClick={onOpenTickets}
                />
              )}
            </Box>
            <List disablePadding>
              {MOCK_TASKS.map((task) => (
                <ListItem key={task.id} disablePadding divider>
                  <ListItemButton dense>
                    <ListItemIcon sx={{ minWidth: 40 }}>
                      <Checkbox edge="start" disabled tabIndex={-1} />
                    </ListItemIcon>
                    <ListItemText
                      primary={task.title}
                      secondary={`Due ${task.due}`}
                    />
                    <Chip size="small" label={task.priority} color={priorityColor(task.priority)} />
                  </ListItemButton>
                </ListItem>
              ))}
            </List>
            <Typography variant="caption" color="text.secondary" sx={{ mt: 1.5, display: 'block' }}>
              Placeholder tasks — wire to assigned tickets in Firestore.
            </Typography>
          </Paper>
        </Grid>

        <Grid size={{ xs: 12, md: 5 }}>
          <Paper variant="outlined" sx={{ p: 2.5, height: '100%' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
              <EventIcon color="primary" />
              <Typography variant="h6">Calendar events</Typography>
            </Box>
            <List dense disablePadding>
              {MOCK_EVENTS.map((event) => (
                <ListItem key={event.id} disableGutters sx={{ py: 1.25, flexDirection: 'column', alignItems: 'flex-start' }}>
                  <Typography variant="subtitle2">{event.title}</Typography>
                  <Typography variant="body2" color="text.secondary">
                    {event.when}
                  </Typography>
                  <Chip size="small" label={event.type} sx={{ mt: 0.5 }} variant="outlined" />
                </ListItem>
              ))}
            </List>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
}
